<template>

  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="10"
            :lg="10"
          >
          <Divider orientation="left">{{langMap.dataReportRecord[lang]}}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="14"
            :lg="14"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.robot[lang]"
                class="leftFlex"
              >
                <Select
                  v-model="robotId"
                  clearable
                  filterable
                >
                  <Option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in robotList"
                  >{{item.name}}</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.dataType[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="type"
                  :placeholder="langMap.dataType[lang]"
                  clearable
                />
              </FormItem>
              <FormItem
                :label="langMap.reportTime[lang]"
                class="leftFlex"
              >
                <Date-picker
                  v-model="times"
                  type="datetimerange"
                  :placeholder="langMap.selectDateAndTime[lang]"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width: 280px"
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{langMap.search[lang]}}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="col"
        :data="list"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="list.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
    </Card>

  </div>
</template>

<script>
import api from "../../../api/index.js";
import * as timeUtil from "@/utils/dateTimeUtil.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
var currentTime = timeUtil.getCurrentTime()
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      robotList: [],
      
      list: [],
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      robotId: "",
      type: "",
      times: [new Date(timeUtil.getRangeDate(1)+currentTime.slice(10)),new Date(currentTime)],
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    col(){
      return[
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: this.langMap.robot[this.lang],
          width: 120,
          key: "code"
        },
        {
          title: this.langMap.messageId[this.lang],
          width: 260,
          key: "messageId"
        },
        {
          title: this.langMap.dataTimestamp[this.lang],
          width: 150,
          key: "timestamp",
          render(h, params) {
            return h("span", timeUtil.formatTime(params.row.timestamp));
          }
        },
        {
          width: 210,
          title: this.langMap.dataType[this.lang],
          key: "type",
          render: (h, params) => {
            return this.hideText(h, params.row.type, "200px");
          }
        },
        {
          width: 310,
          title: this.langMap.parameters[this.lang],
          key: "param",
          render: (h, params) => {
            return this.hideText(h, params.row.param, "300px");
          }
        },
        {
          width: 570,
          title: this.langMap.data[this.lang],
          key: "data",
          render: (h, params) => {
            return this.hideText(h, params.row.data, "560px");
          }
        },
        {
          title: this.langMap.createTime[this.lang],
          width: 150,
          key: "createTime",
          render(h, params) {
            var text = "";
            if (params.row.createTime) {
              text = params.row.createTime;
            } else {
              text = "-";
            }
            return h("span", text);
          }
        }
      ]
    }
  },
  methods: {
    hideText(h, text, width) {
      return h("div", [
        // 显示的位置上方
        h(
          "Tooltip",
          {
            props: { placement: "top", transfer: true }
          },
          [
            h(
              "span",
              {
                style: {
                  display: "inline-block",
                  width: width,
                  overflow: "hidden",
                  // 同样在这里隐藏溢出内容
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }
              },
              text
            ),
            // 显示的内容
            h(
              "span",
              {
                slot: "content",
                style: { whiteSpace: "normal", wordBreak: "break-all" }
              },
              text
            )
          ]
        )
      ]);
    },
    //获取列表
    getList() {
      this.tableLoading = true;
      let stat = "";
      let end = "";
      if (this.times.length == 2) {
        if (this.times[0]) {
          stat = this.times[0].getTime();
        }
        if (this.times[1]) {
          end = this.times[1].getTime();
        }
      }
      api
        .getData(
          "notice-server/record/upload/data/page?index=" +
            this.index +
            "&robotId=" +
            (this.robotId || "") +
            "&type=" +
            this.type+
            "&startTime="+
            stat+
            "&endTime="+end,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: this.langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.list = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    getRobotList() {
      //this.$Spin.show();
      api.getData("robot-server/robot/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.robotList = res.data;
          if(this.robotList.length){
            this.robotId = this.robotList[0].id
          }
          this.getList();
        }
        //this.$Spin.hide();
      });
    }
  },
  created() {
    this.getRobotList();
  }
};
</script>

<style>
</style>
